import Vue from 'vue';
import ZKElementUI from '@zk/element-ui';
import 'zk-ui/lib/theme-chalk/index.css';
import '@zk/element-ui/lib/theme-chalk/index.css';

Vue.use(ZKElementUI);
